// src/components/Footer.js
import React from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import ReviewsCTA from "./ReviewsCTA";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Réseaux sociaux */}
        <div className="footer-socials">
          <a
            href="https://www.facebook.com/profile.php?id=61565497088426"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            title="Facebook"
          >
            <FaFacebookF size={20} />
          </a>
          <a
            href="https://www.instagram.com/hlbkphoto"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            title="Instagram"
          >
            <FaInstagram size={20} />
          </a>
        </div>

        {/* Avis Google */}
        <ReviewsCTA 
          href="https://g.page/r/CWoruq03bw4oEAE/review" 
          text="Laisser un avis Google"
        />
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} HLBK — Photographe · Tous droits réservés
        </p>
      </div>
    </footer>
  );
}